import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/auction-market-car-hammer-price-conditions.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { AuctionsHammerPrices } from "@/types/auctions";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for auction cars
  const mock = AxiosMock.getInstance();
  const uri = new RegExp(
    "^\/carburate\/ad_listings\/market_cars\/.+\/hammer_price_by_conditions\/$"
  );
  mock.onGet(uri).reply(200, data);
}

export const getAdListingMarketCarHammerPriceByConditions = (marketCarId: string) => {
  return api.get(
    `/carburate/ad_listings/market_cars/${marketCarId}/hammer_price_by_conditions/`
  ) as Promise<AuctionsHammerPrices>;
};

export const getAdListingMarketCarHammerPriceByConditionsQueryOptions = ({
  marketCarId,
}: {
  marketCarId: string;
}) => {
  return queryOptions({
    queryKey: ["market-car-ad-listings", marketCarId, "hammer-price-by-conditions"],
    queryFn: () => getAdListingMarketCarHammerPriceByConditions(marketCarId),
  });
};

type UseAdListingMarketCarHammerPriceByConditionsOptions = {
  marketCarId: string;
  queryConfig?: QueryConfig<typeof getAdListingMarketCarHammerPriceByConditions>;
};

export const useAdListingMarketCarHammerPriceByConditions = ({
  marketCarId,
  queryConfig,
}: UseAdListingMarketCarHammerPriceByConditionsOptions) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getAdListingMarketCarHammerPriceByConditionsQueryOptions({ marketCarId }),
    ...queryConfig,
  });
};
